import { Dispatch } from "redux";
import appStateModel from "../../globals/redux/models";
import * as LoginActions from "./login.actions";
import { AuthenticationService } from "../../services/authenticationService";
import dayjs from "dayjs";
import { RootState } from "../../globals/redux/store/store.index";
import * as ChatActions from "../chatV2/chat.actions";
export const authenticateUser = (username: string, password: string) => {
    return async (dispatch: Dispatch<any>, getState: () => appStateModel) => {
        try {
            const response = await AuthenticationService.authentication(
                username,
                password,
            );
            response.data.system_overload &&
                dispatch(
                    ChatActions.setSystemOverload(
                        response.data.system_overload,
                        response.data.message,
                    ),
                );
            if(response.data?.user_meta_table === "yes"){
                window.location.href =`/verify-otp?email=${username}&flow=register`;
                alert("Your account is not verified, Please enter the OTP sent to verify your account");
                return;
            }
            const qnaAccessGroupString = "QnA Access Group";
            const betaTesterGroupString = "Beta Testers";
            const videoAccessGroupString = "Video Access Group";
            const canAccessQnA =
                response.data.groups.indexOf(qnaAccessGroupString) > -1;
            const isBetaTester =
                response.data.groups.indexOf(betaTesterGroupString) > -1;
            const isParticipated = response.data.is_participated;
            const showParticipateButton = response.data.show_participation;
            // const canAccessVideo = response.data.groups.indexOf(videoAccessGroupString) > -1;

            localStorage.setItem("authenticatedUser", username);
            localStorage.setItem("isParticipated", isParticipated);
            localStorage.setItem("showParticipateButton", showParticipateButton);
            // localStorage.setItem("authenticationToken", response.data.access);
            // localStorage.setItem("refreshToken", response.data.refresh);
            localStorage.setItem("authenticationToken", response.data.access);
            localStorage.setItem("refreshToken", response.data.refresh);
            localStorage.setItem("freeUsageAllowed", '0');
            localStorage.setItem(
                "refreshTokenExpiresOn",
                dayjs(new Date()).add(4, "day").toISOString(),
            );
            localStorage.setItem("canAccessQnA", canAccessQnA ? "yes" : "no");
            localStorage.setItem("isBetaTester", isBetaTester ? "yes" : "no");
            // localStorage.setItem("canAccessVideo", canAccessVideo ? "yes" : "no");
            localStorage.setItem("wsToken", response.data.ws_token);

            dispatch(LoginActions.setAuthenticationStatus("successful"));
        } catch (error) {
            console.log(error);
            if(error.response===undefined){
                dispatch(LoginActions.setAuthenticationStatus("We’re experiencing technical difficulties, Please try again later or contact support if the issue persists"));
            }else{
                dispatch(LoginActions.setAuthenticationStatus(error.response.data.detail));
            }
            
            console.log("Error during authentication:", error?.response.data.detail);

        }
    };
};

export const googleLogin = (token: string) => {
    return async (dispatch: Dispatch<any>, getState: () => appStateModel) => {
        try {
            const response = await AuthenticationService.googlelogin(token);
            const isParticipated = response.data.is_participated;
            const showParticipateButton = response.data.show_participation;
            const qnaAccessGroupString = "QnA Access Group";
            const betaTesterGroupString = "Beta Testers";
            const videoAccessGroupString = "Video Access Group";
            const canAccessQnA =
                response.data.groups.indexOf(qnaAccessGroupString) > -1;
            const isBetaTester =
                response.data.groups.indexOf(betaTesterGroupString) > -1;
            // const canAccessVideo = response.data.groups.indexOf(videoAccessGroupString) > -1;

            localStorage.setItem("authenticatedUser", response.data.username);
            localStorage.setItem("isParticipated", isParticipated);
            localStorage.setItem("showParticipateButton", showParticipateButton);
            // localStorage.setItem("authenticationToken", response.data.access);
            // localStorage.setItem("refreshToken", response.data.refresh);
            localStorage.setItem("authenticationToken", response.data.access);
            localStorage.setItem("refreshToken", response.data.refresh);
            localStorage.setItem(
                "refreshTokenExpiresOn",
                dayjs(new Date()).add(4, "day").toISOString(),
            );
            localStorage.setItem("canAccessQnA", canAccessQnA ? "yes" : "no");
            localStorage.setItem("isBetaTester", isBetaTester ? "yes" : "no");
            // localStorage.setItem("canAccessVideo", canAccessVideo ? "yes" : "no");
            localStorage.setItem("wsToken", response.data.ws_token);
            dispatch(LoginActions.setAuthenticationStatus("successful"));
        } catch (error) {
            dispatch(LoginActions.setAuthenticationStatus("failed"));
        }
    };
};
